module.exports = __webpack_public_path__ + "static/iso-18001-6a6775116feafddffeeee449c68b6e77.png";